export default [
    ['SUMMARY', '需求架构'],
    ['ARCH_SYS', '系统架构'],
    ['DOMAIN_KNOWLEDGE', '领域知识'],
    ['STANDARD', '建模技能'],
    ['COMMON', '其他']
]
